<template lang="html">

  <div class="politica-de-cookies">

    <section class="intro-legales column-center launch">

      <h1 class="subtitle-intro">
        <span>{{$t("intros_legales.datos_seguros")}}</span>
      </h1>

    </section> 

    <section class="textos-legales container">

      <p>{{$t('datos_seguros.p1')}}</p>
      <p>{{$t('datos_seguros.p2')}}</p>
      <p>{{$t('datos_seguros.p3')}}</p>
      <p>{{$t('datos_seguros.p4')}}</p>
      <p>{{$t('datos_seguros.p5')}}</p>

      <h2 v-html=" $t('datos_seguros.h21') "></h2>

      <p v-html=" $t('datos_seguros.p6') "></p>

      <p v-html=" $t('datos_seguros.p7') "></p>

      <p v-html=" $t('datos_seguros.p8') "></p>

      <p v-html=" $t('datos_seguros.p9') "></p>

      <p v-html=" $t('datos_seguros.p10') "></p>

      <p v-html=" $t('datos_seguros.p11') "></p>

      <p v-html=" $t('datos_seguros.p12') "></p>

      <p>{{$t('datos_seguros.p13')}}</p>



      <h2 v-html=" $t('datos_seguros.h22') "></h2>
      <p>{{$t('datos_seguros.p14')}}</p>
      <p>{{$t('datos_seguros.p15')}}</p>

      <h2>{{ $t('datos_seguros.h23') }}</h2>
      <p>{{$t('datos_seguros.p16')}}</p>

      <h2 v-html=" $t('datos_seguros.h24') "></h2>
      <p v-html=" $t('datos_seguros.p17') "></p>
      <p v-html=" $t('datos_seguros.p18') "></p>
      <p v-html=" $t('datos_seguros.p181') "></p>

      <p v-html=" $t('datos_seguros.p19') "></p>
      <p v-html=" $t('datos_seguros.p20') "></p>

      <h2 v-html=" $t('datos_seguros.h25') "></h2>

      <p v-html=" $t('datos_seguros.p21') "></p>
      <p v-html=" $t('datos_seguros.p22') "></p>
      <h2 v-html=" $t('datos_seguros.h26') "></h2>
      <p v-html=" $t('datos_seguros.p23') "></p>
      <p v-html=" $t('datos_seguros.p24') "></p>

      <h2 v-html=" $t('datos_seguros.h27') "></h2>
      <p v-html=" $t('datos_seguros.p25') "></p>

      <h2 v-html=" $t('datos_seguros.h28') "></h2>
      <p v-html=" $t('datos_seguros.p26') "></p>
      <p v-html=" $t('datos_seguros.p27') "></p>
      <p v-html=" $t('datos_seguros.p28') "></p>
      <p v-html=" $t('datos_seguros.p29') "></p>
      <p v-html=" $t('datos_seguros.p30') "></p>

      <h2 v-html=" $t('datos_seguros.h29') "></h2>
      <p v-html=" $t('datos_seguros.p31') "></p>
      <p v-html=" $t('datos_seguros.p32') "></p>

      <h2 v-html=" $t('datos_seguros.h210') "></h2>
      <p v-html=" $t('datos_seguros.p33') "></p>
      <p v-html=" $t('datos_seguros.p333') "></p>

      <p v-html=" $t('datos_seguros.p34') "></p>
      <p v-html=" $t('datos_seguros.p35') "></p>
      <p v-html=" $t('datos_seguros.p36') "></p>
      <p v-html=" $t('datos_seguros.p37') "></p>
      <p v-html=" $t('datos_seguros.p38') "></p>
      <p v-html=" $t('datos_seguros.p39') "></p>
      <p v-html=" $t('datos_seguros.p40') "></p>
      <p v-html=" $t('datos_seguros.p41') "></p>

      <h2 v-html=" $t('datos_seguros.h211') "></h2>
      <p v-html=" $t('datos_seguros.p42') "></p>
      <p v-html=" $t('datos_seguros.p43') "></p>
      <p v-html=" $t('datos_seguros.p44') "></p>
      <p v-html=" $t('datos_seguros.p45') "></p>

      <h2 v-html=" $t('datos_seguros.h212') "></h2>
      <p v-html=" $t('datos_seguros.p43') "></p>




    </section>

  </div>

</template>

<script lang="js">
  export default  {
    name: 'politica-de-cookies',
  }
</script>

<style>
p{
  word-break:break-all
}
</style>


// WEBPACK FOOTER //
// src/components/views/datos-seguros.vue